import { AfterViewInit, Component, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { ResizedEvent } from 'angular-resize-event';
import { DEFAULT_THEME as defaultTheme } from '@nebular/theme';
import { Social_Platform,
  Material_Design_Red, 
  Material_Design_Pink, 
  Material_Design_Purple, 
  Material_Design_Deep_Purple,
  Material_Design_Lime,
  Classic_20 } from '../config/color-palettes';

@Component({
  selector: 'nbx-line-echart',
  templateUrl: './linechart.component.html',
  styleUrls: ['./linechart.component.scss']
})
export class LineEchartComponent implements AfterViewInit, OnChanges {
  @Input() resizable: boolean = true;
  autoResize = true;

  width: number;
  height: number;
  defaultThemeVariables = defaultTheme.variables;
  @Input() tooltipstr: string = '';
  @Input() legendstr: string = '';
  @Input() seriesstr: string = '';
  @Input() titlestr: string = '';
  @Input() gridstr: string = '';
  @Input() xaxisstr: string = '';
  @Input() yaxisstr: string = '';

  options: any = {};
  title: any;
  tooltip: any;
  legend: any;
  series: any;
  grid: any;
  xaxis: any;
  yaxis: any;

  echartsInstance: any;

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;

    if (this.echartsInstance)
    {
      this.echartsInstance.resize({
        height: event.newHeight
      });
    }
  }

  ngAfterViewInit() {

    //set defaults 
    this.tooltip= (this.tooltipstr == '') ?  {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          color: this.defaultThemeVariables.fgText,
          backgroundColor: this.defaultThemeVariables.tooltipBackgroundColor,
        },
      },
    } : JSON.parse(this.tooltipstr);

    this.legend = (this.legendstr == '') ? {
      orient: "horizontal", 
      data: ['Mail marketing', 'Affiliate advertising', 'Video ad', 'Direct interview', 'Search engine', 'Data'],
      textStyle: {
        color: this.defaultThemeVariables.fgText,
      },
    } : JSON.parse(this.legendstr);

    this.grid = (this.gridstr == '') ? {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    } : JSON.parse(this.gridstr);

    this.xaxis = (this.xaxisstr == '') ? [
      {
        type: 'category',
        boundaryGap: false,
        data: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        axisTick: {
          alignWithLabel: true,
        },
        axisLine: {
          lineStyle: {
            color: this.defaultThemeVariables.axisLineColor,
          },
        },
        axisLabel: {
          textStyle: {
            color: this.defaultThemeVariables.fgText,
          },
        },
      },
    ] : JSON.parse(this.xaxisstr);

    this.yaxis = (this.yaxisstr == '') ? [
      {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: this.defaultThemeVariables.axisLineColor,
          },
        },
        splitLine: {
          lineStyle: {
            color: this.defaultThemeVariables.splitLineColor,
          },
        },
        axisLabel: {
          textStyle: {
            color: this.defaultThemeVariables.fgText,
          },
        },
      },
    ] : JSON.parse(this.yaxisstr);

    this.series = (this.seriesstr == '') ? [
      {
        name: 'Mail marketing',
        type: 'line',
        stack: 'Total amount',
        data: [120, 132, 101, 134, 90, 230, 210],
      }
    ] : JSON.parse(this.seriesstr);

      this.options = {
        backgroundColor: "transparent",
        color: Object.values(Classic_20),
        tooltip: this.tooltip,
        legend: this.legend,
        grid: this.grid,
        xAxis: this.xaxis,
        yAxis: this.yaxis,
        series: this.series
      };
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes)
    {
      if (changes.hasOwnProperty(propName))
      {
        switch(propName) {
          case 'tooltipstr': {
            console.log("tooltip update");
              this.updateOptions('tooltip',this.tooltipstr);
            break;     
          }
          case 'legendstr': {
            console.log("legend update");
              this.updateOptions('legend',this.legendstr);
            break;
          }
          case 'seriesstr': {
            console.log("series update");
              this.updateOptions('series',this.seriesstr);
            break;
          }
          case 'titlestr': {
            console.log("title update");
              this.updateOptions('title',this.titlestr);
            break;
          }
          case 'gridstr': {
            console.log("grid update");
              this.updateOptions('grid',this.gridstr);
            break;
          }
          case 'xaxisstr': {
            console.log("xaxis update");
              this.updateOptions('xaxis',this.xaxisstr);
            break;
          }
          case 'yaxisstr': {
            console.log("yaxis update");
              this.updateOptions('yaxis',this.yaxisstr);
            break;
          }
        }
      }
    }

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Classic_20),
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      grid: this.grid,
      xAxis: this.xaxis,
      yAxis: this.yaxis,
      series: this.series
    }

  }
    onChartInit(e: any) {
      this.echartsInstance = e;
      console.log('on chart init:', e);
    }

    private updateOptions(opt, value) {
      console.log(opt)
      console.log(value)
      this[opt] = JSON.parse(value);
      console.log(this[opt]);

      this.options[opt] = this[opt];

      console.log(this.options);  
    }
}